import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getTalkingPointList = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/briefs/talking-points?${queries}` });

  return data?.data;
};

export default getTalkingPointList;
